import React, { useEffect, useState } from "react";
import PageTableHeader from "../../../../../components/pageTableHeader/pageTableHeader";
import { DefaultSelectFilter } from "../../../../../components/inputs/defaultSelectFilter";
import CommonModal from "../../../../../components/modals/commonModel";
import toast from "react-hot-toast";
import {
  deleteCategory,
  getCategoryList,
} from "../../../../../../services/workspace/inventory.service";
import PaginationComponent from "../../../../../components/table/tablePagination";
import ManageSalaryForm from "../../../../../components/forms/payrole/manageSalaryForm";
import SalaryReportTable from "./components/table";
import { useParams } from "react-router-dom";
import {
  deleteSalary,
  getDownloadPaySlip,
  getSalaryReportDetails,
  paySalaryByAllStaff,
  paySalaryByStaff,
} from "../../../../../../services/workspace/payroll.service";
import PaySalaryForm from "./paySalaryForm";
import DefaultButton from "../../../../../components/buttons/defaultButton";
import ConfirmModal from "../../../../../components/modals/ConfirmModel";
import { downloadFile } from "../../../../../../utils/helper";

const items = [
  { label: "Home", path: "/" },
  { label: "Payroll", path: "/payroll" },
  { label: "Salary Report", path: "/payroll/salary-report" },
  { label: "Detail", path: "" },
];

const tableHeading = [
  "Employee Name",
  "Date of Joining",
  "Department",
  "Designation",
  "Designation",
  "Total Days",
  "Present",
  "Absent",
  "Leave",
  "Holiday/Friday",
  "Transport Allowance",
  "Additional Allowance",
  "Net Salary",
];

function SalaryReportDetails() {
  const { id } = useParams();
  const [selectedValue, setSelectedValue] = useState("desc");

  // const [selectedOption, setSelectedOption] = useState(""); // Default value as empty string
  // const [isError, setIsError] = useState(false);
  const [search, setSearch] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); 
  const [downloadLoading, setdownloadLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(false);
  const [totalData, setTotalData] = useState(0);

  const { limit } = useState(10);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);

  // const [selected, setSelected] = useState(false);

  const fetchData = () => {
    setLoading(true);
    getSalaryReportDetails(id)
      .then((response) => {
        setLoading(false);
        response?.salary_report_users.map((item) => {
          item.forPaid = false;
        });
        setTableData(response?.salary_report_users || []);
        setTotalData(response.total || 0);
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Failed to fetch designation data!");
        console.error(error);
      });
  };

  const handleUpdateForAll = () => {
    const forPaid = tableData[0].forPaid ? false : true;
    tableData
      .filter((d) => !d.is_paid)
      .map((item) => {
        item.forPaid = forPaid;
      });
    setTableData([...tableData]);
  };

  const handleUpdateForMakeSalary = (id) => {
    const indexId = tableData.findIndex((staff) => staff.id === id);
    tableData[indexId].forPaid = !tableData[indexId].forPaid;
    // Calculating net salary and updating

    setTableData([...tableData]);
  };

  // Debounce search functionality for optimized performance
  useEffect(() => {
    const timer = setTimeout(
      () => {
        fetchData();
      },
      search ? 500 : 0
    ); // Adjust debounce time as needed

    return () => clearTimeout(timer);
  }, [search, currentPage, limit, selectedValue, id]);

  // Function to handle modal toggle
  const toggleModal = (data = "") => {
    if (data) {
      setSelectedData(data);
      setIsModalOpen(!isModalOpen);
    } else {
      setIsModalOpen(!isModalOpen);
    }
  };

  const handleSelectChange = (e) => {
    setSelectedValue(e.target.value);
  };

  const handleStatus = (id) => {
    setSelectedId(id);
    setIsOpen(true);
  };

  const onConfirm = () => {
    deleteSalary(selectedId)
      .then((response) => {
        fetchData();
        toast.success("Salary deleted successfully!");
      })
      .catch((error) => {
        toast.error(
          "This item cannot be deleted because it is referenced in other records. Please remove any associated entries in related tables before retrying."
        );
      });

    setSelectedId(false);
    setIsOpen(false);
  };

  const onConfirmSingle = () => {
   
    paySalary('single');
    setIsModalOpen(false);
 
  };

  const paySalary = (type) => {
    if (type === 'single') {
    let payload = {
      status: 1,
    };
    paySalaryByStaff(selectedData.uuid, payload)
      .then((response) => {
        toast.success("Payment created successfully!");
        fetchData();
      })
      .catch((error) => {
        toast.error(
          `Failed to create Payment: ${
            error.response?.data?.message || error.message
          }`
        );
        console.error("Error creating payment:", error);
      })
      .finally(() => {
        setIsSubmitting(false);
       
        setSelectedData([]);
       
      });
    }else{
      let uuids = [];
      tableData.map((item) => {
        if(item.status != 1 && item.forPaid){
          uuids.push(item.uuid);
        }
      });
      let payload = {
        "status": 1,
    "uuids":uuids
      };
      paySalaryByAllStaff( payload)
        .then((response) => {
          toast.success("Payment created successfully!");
          fetchData();
        })
        .catch((error) => {
          toast.error(
            `Failed to create Payment: ${
              error.response?.data?.message || error.message
            }`
          );
          console.error("Error creating payment:", error);
        })
        .finally(() => {
          setIsConfirmOpen(false);
          setIsSubmitting(false);
          setSelectedData([]);
         
        });
    }
  };

  const downloadPaySlip = async (id) => {

    setdownloadLoading(true)
    try {
      const response = await getDownloadPaySlip(id);
     
      if (response) {
        
        downloadFile(response.download_url, "PaySlip");
      }
    } catch (error) {
      console.error("Error fetching assignment data:", error);
    } finally {
      setdownloadLoading(false);
    }

  };

  return (
    <div className="flex flex-col gap-2">
      <PageTableHeader
        breadcrumbs={items}
        isSearch={true}
        onSearchChange={(e) => setSearch(e.target.value)}
        isFilter={false}
        buttons={false}
      />

      <div className=" flex flex-col ">
        <div className="flex flex-row gap-2 p-4 text-theme font-bold items-center bg-white">
          <h2>Salary Details</h2>
          <DefaultSelectFilter
            className="bg-light hover:bg-bghoverlight px-2 rounded-md flex flex-row gap-1"
            label="Sort By"
            options={[
              { label: "Newest First", value: "desc" },
              { label: "Oldest First", value: "asc" },
            ]}
            name={"filter"}
            onChange={handleSelectChange}
            // error={isError}
            errorMsg="Please select an option"
          />
        </div>

        <div className="flex flex-col gap-2">
          <SalaryReportTable
            tableHeading={tableHeading}
            tableData={tableData}
            onClick={onclick}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            loading={loading}
            toggleModal={toggleModal}
            handleStatus={handleStatus}
            onConfirm={onConfirm}
            handleUpdateForAll={handleUpdateForAll}
            handleUpdateForMakeSalary={handleUpdateForMakeSalary}
            downloadPaySlip={downloadPaySlip}
            downloadLoading={downloadLoading}
          />
          {/* {!loading && tableData && !!tableData.length && ( */}
          {tableData &&
            !!tableData.length &&
            tableData.some((data) => data.forPaid) && (
              <div className="flex flex-row gap-2 items-center">
                <DefaultButton
                  minWidth
                  name="Pay Salary"
                  variant=""
                  loading={isSubmitting}
                  onClick={() => setIsConfirmOpen(true)}
                />
              </div>
            )}
        </div>
      </div>
      <ConfirmModal
        isOpen={isConfirmOpen}
        title="Are you sure?"
        message="Do you want Pay Salary Please confirm."
        onConfirm={() => paySalary('all')}
        onCancel={() => setIsConfirmOpen(false)}
      />

      <ConfirmModal
        isOpen={isModalOpen}
        title="Are you sure?"
        message="Do you want Pay Salary Please confirm."
        onConfirm={onConfirmSingle}
        onCancel={() => setIsModalOpen(false)}
      />

      
    </div>
  );
}

export default SalaryReportDetails;
